import { defineSchema, SchemaInstance } from "../type-system/schema";

export const extendedWarrantySchema = defineSchema({
  fields: {
    redoCustomerId: { dataType: "Text", documentation: "Redo customer ID" },
    customerFullName: {
      dataType: "Text",
      documentation:
        "The full name of the customer who purchased the extended warranty.",
    },
    customerEmail: {
      dataType: "Email",
      documentation:
        "The email address of the customer who purchased the extended warranty.",
    },
    teamName: {
      dataType: "Text",
      documentation:
        "The name of the team/store that sold the extended warranty.",
    },
    purchaseDate: {
      dataType: "Date",
      documentation: "The date when the extended warranty was purchased.",
    },
    effectiveDate: {
      dataType: "Date",
      documentation: "The date when the extended warranty coverage begins.",
    },
    expirationDate: {
      dataType: "Date",
      documentation: "The date when the extended warranty coverage expires.",
    },
    coverageTermDays: {
      dataType: "Number",
      documentation:
        "The number of days the extended warranty provides coverage.",
    },
    purchasePrice: {
      dataType: "Number",
      documentation: "The price paid for the extended warranty.",
    },
    orderName: {
      dataType: "Text",
      documentation:
        "The name/number of the order containing the extended warranty purchase.",
    },
    productTitle: {
      dataType: "Text",
      documentation:
        "The title of the product being covered by the extended warranty.",
    },
    variantTitle: {
      dataType: "Text",
      documentation: "The title of the specific product variant being covered.",
    },
    sku: {
      dataType: "Text",
      documentation:
        "The SKU of the product variant being covered by the extended warranty.",
    },
  },
});

export const exampleExtendedWarrantySchemaInstance: SchemaInstance<
  typeof extendedWarrantySchema
> = {
  redoCustomerId: "66b131782f9829bd1ed05bd7",
  customerFullName: "John Doe",
  customerEmail: "john.doe@example.com",
  teamName: "Example Store",
  purchaseDate: Temporal.PlainDate.from("2024-01-15"),
  effectiveDate: Temporal.PlainDate.from("2024-01-15"),
  expirationDate: Temporal.PlainDate.from("2025-01-15"),
  coverageTermDays: 365,
  purchasePrice: 99.99,
  orderName: "#1001",
  productTitle: "Premium Smartphone",
  variantTitle: "Premium Smartphone - Black - 128GB",
  sku: "PHONE-BLK-128GB",
};
